<template>
    <Descriptions bordered :column="1">
        <DescriptionsItem v-if="form.approveCode2" key="approveCode2" :label="t('model.haz.info.documentCode')" size="small">{{ form.approveCode2 }}</DescriptionsItem>
        <DescriptionsItem v-if="form.approveCode" key="approveCode" :label="t('model.haz.approveCode')" size="small">{{ form.approveCode }}</DescriptionsItem>
        <DescriptionsItem v-if="form.approveCodeOld" key="approveCodeOld" :label="t('model.haz.approveCodeOld')" size="small">{{ form.approveCodeOld }}</DescriptionsItem>
        <DescriptionsItem v-if="form.refUserCompany && form.refUserCompany.companyNameTh" key="refUserCompany" :label="t('model.haz.refUserCompany')" size="small">{{ form.refUserCompany.companyNameTh }}</DescriptionsItem>
        <DescriptionsItem v-if="form.refOperation && form.refOperation.value" key="refOperation" :label="t('model.haz.refOperation')" size="small">{{ form.refOperation.value }}</DescriptionsItem>
        <DescriptionsItem v-if="form.refHazObject && form.refHazObject.nameTh" key="refHazObject" :label="t('model.haz.refHazObject')" size="small">{{ form.refHazObject.nameTh }}</DescriptionsItem>
        <DescriptionsItem v-if="form.tradeNameTh" key="tradeNameTh" :label="t('model.haz.info.tradeName')" size="small">{{ form.tradeNameTh }}</DescriptionsItem>
        <!-- DescriptionsItem v-if="form.manufacturer" key="manufacturer" :label="t('model.haz.manufacturer')" size="small">{{ form.manufacturer }}</DescriptionsItem-->
        <DescriptionsItem v-if="form.distributors" key="distributors" :label="t('model.haz.info.distributorName')" size="small">
            <div v-for="(item) in form.distributors" :key="item.id || item._id">
                {{ item.refDistributor.fullNameTh }}
            </div>
        </DescriptionsItem>
        <DescriptionsItem v-if="form.refUserCompany?.address1List" key="distributors" :label="t('model.haz.info.refUserCompanyProvince')" size="small">
            <div v-for="(item) in form.refUserCompany?.address1List" :key="item.id || item._id">
                {{ item.refProvince.nameTh }}
            </div>
        </DescriptionsItem>
        <DescriptionsItem v-if="form.effectiveDate" key="effectiveDate" :label="t('model.haz.effectiveDate')" size="small"><Date :text="form.effectiveDate" format="DD/MM/YYYY"></Date></DescriptionsItem>
        <DescriptionsItem v-if="form.expireDate" key="expireDate" :label="t('model.haz.expireDate')" size="small"><Date :text="form.expireDate" format="DD/MM/YYYY"></Date></DescriptionsItem>
        <DescriptionsItem v-if="form.refStatus && form.refStatus.value" key="refStatus" :label="t('model.haz.refStatus')" size="small">
            {{ form.refStatus.value }} <span v-if="form.expireDate && moment().diff(form.expireDate, 'days') >= 0" class="text-danger"> (หมดอายุ)</span>
        </DescriptionsItem>
    </Descriptions>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { Descriptions } from "ant-design-vue";
import { state as stateApp } from "../../../../app.logic";
import { useRoute } from "vue-router";
import { t } from "../short-detail.logic";
import moment from "moment";

export default defineComponent({
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
        Date: defineAsyncComponent(() => import("../../../../components/table/custom-render/Date")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        form: { default: {} }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        return {
            props,
            data,
            refs,
            moment,
            t
        };
    }
});
</script>